/**
 * Las dos decisiones del cargador, fuera del componente para poder probarlas.
 *
 * No es separación por gusto: lo que importa aquí —qué archivo se rechaza y
 * cuándo la barra deja de contar— es lógica, y enterrarla dentro del JSX
 * obligaría a montar React sólo para comprobarla.
 */

/** El mismo tope que aplica el servidor. Aquí sólo para avisar antes de subir. */
export const MAXIMO_BYTES = 20 * 1024 * 1024;

/** Motivo por el que un archivo no llega a salir del navegador. */
export type Rechazo = 'noEsPdf' | 'demasiadoGrande' | 'vacio';

/**
 * Se mira el tipo **y** la extensión porque no siempre hay tipo: al arrastrar
 * desde algunos gestores de archivos `File.type` llega vacío, y rechazar por eso
 * un PDF legítimo es peor que dejar que el servidor —que decide por la firma del
 * contenido, no por el nombre— diga la última palabra.
 */
export function revisarArchivo(archivo: { name: string; size: number; type: string }): Rechazo | null {
  const pareceUnPdf =
    archivo.type === 'application/pdf' || archivo.name.toLowerCase().endsWith('.pdf');
  if (!pareceUnPdf) return 'noEsPdf';
  if (archivo.size === 0) return 'vacio';
  if (archivo.size > MAXIMO_BYTES) return 'demasiadoGrande';
  return null;
}

export type Fase =
  | { estado: 'quieto' }
  | { estado: 'subiendo'; porcentaje: number; nombre: string }
  | { estado: 'procesando'; nombre: string };

/**
 * Al llegar a 100 la barra **no** se queda llena: el archivo terminó de viajar
 * pero el servidor sigue escaneándolo con antivirus y contando sus páginas,
 * varios segundos en un PDF grande. Una barra completa sobre una pantalla que no
 * responde se lee como «se colgó», así que a partir de ahí la fase lo dice.
 */
export function faseDesde(porcentaje: number, nombre: string): Fase {
  return porcentaje >= 100
    ? { estado: 'procesando', nombre }
    : { estado: 'subiendo', porcentaje: Math.max(0, Math.min(100, porcentaje)), nombre };
}
